module.exports = __webpack_public_path__ + "static/media/CLA_CSV_6.2ba628ef.svg";